import './index.scss';

import React from 'react';
import { Redirect } from 'react-router-dom';
import Config from '../../config';

export default class extends React.Component {

  state = {
    facebook: false,
    google: false
  };

  render() {
    return (
      <div className="content-inner-container thank-you">
        <div className="thank-you-inner">
          <i className="fa fa-smile-o" />
          <p>
            <strong>Thank you!</strong>
          </p>
          <p>
            We need your help. Would you share your experience on one of these sites?
          </p>
          <div className="sites-holder">
          {console.log(Config.getFacebookReviewLink())}
            {Config.getFacebookReviewLink() === ''? null :
              (
                <div className="site" onClick={() => this.setState({ facebook: true })}>
                  <i className="fa fa-facebook" />
                  <p>
                    <strong>Facebook</strong>
                  </p>
                </div>
              )
            }

            {Config.getGoogleReviewLink() === ''? null :
              (
              <div className="site" onClick={() => this.setState({ google: true })}>
                <i className="fa fa-google" />
                <p>
                  <strong>Google</strong>
                </p>
              </div>
              )
            }

          </div>
        </div>
        {
          this.state.facebook ? (
            <Redirect to={`/${this.props.match.params.group}/${this.props.match.params.key}/thank-you/facebook`} />
          ) : null
        }
        {
          this.state.google ? (
            <Redirect to={`/${this.props.match.params.group}/${this.props.match.params.key}/thank-you/google`} />
          ) : null
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/states/thank-you/index.js